import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { default as Messages } from 'react-notify-toast';
import { Grid, Row, Col } from 'react-bootstrap';
import firebase from 'firebase';
import { VERSION, SUPERADMIN } from './config';
import Navigation from './components/Navigation';
import Home from './pages/Home';
import Login from './pages/Login';
import Phrases from './pages/Phrases';
import Grammar from './pages/Grammar';
import Settings from './pages/Settings';
import Users from './pages/Users';
import Words from './pages/Words';
import Lessons from './pages/Lessons';
import Topics from './pages/Topics';
import Notifications from './pages/Notifications';
import Feedback from './pages/Feedback';
import Statistics from './pages/Statistics';
import Superadmin from './pages/Superadmin';

type IState = {
  logged: boolean,
  room: string,
};

class App extends Component {
  constructor(props: any) {
    super(props);

    this.state = {
      logged: true,
      room: '',
    };
  }

  state: IState;

  componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        const room = localStorage.getItem('room') || '';
        if (room !== '') {
          this.setState({
            logged: true,
            room,
          });
          return;
        }
      }
      localStorage.removeItem('room');
      this.setState({
        logged: false,
        room: '',
      });
    });
  }

  handleOnSignedIn() {
    const room = localStorage.getItem('room') || '';
    if (room !== '') {
      this.setState({
        logged: true,
        room,
      });
    } else {
      localStorage.removeItem('room');
      this.setState({
        logged: false,
        room: '',
      });
    }
  }

  render() {
    const { logged, room } = this.state;

    let children = null;

    if (!(logged && firebase.auth().currentUser)) {
      children = (
        <Login
          onSuccess={() => {
            this.handleOnSignedIn();
          }}
        />
      );
    } else {
      children = (
        <BrowserRouter>
          <div>
            <Route
              path='/:page?'
              render={props => <Navigation room={room} {...props} />}
            />
            <Grid>
              <Row style={{ minHeight: '400px' }}>
                <Col>
                  {SUPERADMIN.indexOf(firebase.auth().currentUser.email) >=
                    0 && (
                    <Route path='/superadmin' component={Superadmin} exact />
                  )}
                  <Route
                    path='/'
                    render={props => <Home room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/lessons'
                    render={props => <Lessons room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/topics'
                    render={props => <Topics room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/users'
                    render={props => <Users room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/vocabulary'
                    render={props => <Words room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/phrases'
                    render={props => <Phrases room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/grammar'
                    render={props => <Grammar room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/settings'
                    render={props => <Settings room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/notifications'
                    render={props => <Notifications room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/messages'
                    render={props => <Feedback room={room} {...props} />}
                    exact
                  />
                  <Route
                    path='/statistics/:section?'
                    render={props => <Statistics room={room} {...props} />}
                    exact
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <p style={{ marginTop: '40px', marginBottom: '20px' }}>
                    Version: {VERSION}, (C) Aleš Berger 2019
                  </p>
                </Col>
              </Row>
            </Grid>
          </div>
        </BrowserRouter>
      );
    }

    return (
      <div>
        <Messages options={{ zIndex: 50000 }} />
        {children}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js